"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelsVisibilityConfig = exports.isInPercent = exports.formatAsPercent = exports.getLabelStyle = exports.getShapeVisiblePart = exports.intersectsParentLabel = exports.getDataLabelAttributes = exports.showAllLabels = exports.hideAllLabels = exports.showStackLabelInAxisRange = exports.showDataLabelInAxisRange = exports.showDataLabels = exports.hideDataLabels = exports.showDataLabel = exports.hideDataLabel = exports.minimizeDataLabel = exports.hasLabelInside = exports.hasShape = exports.hasDataLabel = exports.areLabelsStacked = exports.getDataLabelsGdcVisible = exports.isLabelOverlappingItsShape = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var helpers_1 = require("./helpers");
var common_1 = require("../_util/common");
var label_1 = require("../../constants/label");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function isLabelOverlappingItsShape(point) {
    var dataLabel = point.dataLabel, shapeArgs = point.shapeArgs;
    if (dataLabel && shapeArgs) {
        // shapeArgs for point hidden by legend is undefined
        if (shapeArgs.width === undefined) {
            return dataLabel.width > shapeArgs.r * 2 || dataLabel.height > shapeArgs.r * 2;
        }
        return dataLabel.width > shapeArgs.width || dataLabel.height > shapeArgs.height;
    }
    return false;
}
exports.isLabelOverlappingItsShape = isLabelOverlappingItsShape;
exports.getDataLabelsGdcVisible = function (chart) { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = chart === null || chart === void 0 ? void 0 : chart.options) === null || _a === void 0 ? void 0 : _a.plotOptions) === null || _b === void 0 ? void 0 : _b.gdcOptions) === null || _c === void 0 ? void 0 : _c.dataLabels) === null || _d === void 0 ? void 0 : _d.visible) !== null && _e !== void 0 ? _e : "auto"; };
var isLabelsStackedFromYAxis = function (chart) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return ((_e = (_d = (_c = (_b = (_a = chart === null || chart === void 0 ? void 0 : chart.userOptions) === null || _a === void 0 ? void 0 : _a.yAxis) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.stackLabels) === null || _d === void 0 ? void 0 : _d.enabled) !== null && _e !== void 0 ? _e : false) ||
        ((_k = (_j = (_h = (_g = (_f = chart === null || chart === void 0 ? void 0 : chart.userOptions) === null || _f === void 0 ? void 0 : _f.yAxis) === null || _g === void 0 ? void 0 : _g[1]) === null || _h === void 0 ? void 0 : _h.stackLabels) === null || _j === void 0 ? void 0 : _j.enabled) !== null && _k !== void 0 ? _k : false);
};
exports.areLabelsStacked = function (chart) {
    return isLabelsStackedFromYAxis(chart) && helpers_1.isStacked(chart);
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.hasDataLabel = function (point) { return !!point.dataLabel; };
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.hasShape = function (point) { return !!point.shapeArgs; };
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.hasLabelInside = function (point) {
    var _a, _b, _c;
    var verticalAlign = (_c = (_b = (_a = point === null || point === void 0 ? void 0 : point.dataLabel) === null || _a === void 0 ? void 0 : _a.alignOptions) === null || _b === void 0 ? void 0 : _b.verticalAlign) !== null && _c !== void 0 ? _c : "";
    return verticalAlign === "middle";
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.minimizeDataLabel = function (point) {
    var dataLabel = point.dataLabel;
    if (dataLabel) {
        dataLabel.width = 0;
        dataLabel.height = 0;
    }
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.hideDataLabel = function (point) {
    var dataLabel = point.dataLabel;
    if (dataLabel) {
        dataLabel.hide();
    }
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.showDataLabel = function (point) {
    var dataLabel = point.dataLabel;
    if (dataLabel) {
        dataLabel.show();
    }
};
exports.hideDataLabels = function (points) {
    points.filter(exports.hasDataLabel).forEach(exports.hideDataLabel);
};
exports.showDataLabels = function (points) {
    points.filter(exports.hasDataLabel).forEach(exports.showDataLabel);
};
function showDataLabelInAxisRange(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
point, value, axisRangeForAxes) {
    var _a, _b, _c;
    var isSecondAxis = (_c = (_b = (_a = point === null || point === void 0 ? void 0 : point.series) === null || _a === void 0 ? void 0 : _a.yAxis) === null || _b === void 0 ? void 0 : _b.opposite) !== null && _c !== void 0 ? _c : false;
    var axisRange = axisRangeForAxes[isSecondAxis ? "second" : "first"];
    var isInsideAxisRange = helpers_1.pointInRange(value, axisRange);
    if (!isInsideAxisRange) {
        exports.hideDataLabel(point);
    }
}
exports.showDataLabelInAxisRange = showDataLabelInAxisRange;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function showStackLabelInAxisRange(point, axisRangeForAxes) {
    var _a, _b, _c;
    var isSecondAxis = (_c = (_b = (_a = point.series) === null || _a === void 0 ? void 0 : _a.yAxis) === null || _b === void 0 ? void 0 : _b.opposite) !== null && _c !== void 0 ? _c : false;
    var axisRange = axisRangeForAxes[isSecondAxis ? "second" : "first"];
    var end = point.stackY || point.total;
    var start = end - point.y;
    var isWholeUnderMin = start <= axisRange.minAxisValue && end <= axisRange.minAxisValue;
    var isWholeAboveMax = start >= axisRange.maxAxisValue && end >= axisRange.maxAxisValue;
    if (isWholeUnderMin || isWholeAboveMax) {
        exports.hideDataLabel(point);
    }
}
exports.showStackLabelInAxisRange = showStackLabelInAxisRange;
exports.hideAllLabels = function (_a) {
    var series = _a.series;
    return exports.hideDataLabels(flatMap_1.default(series, function (s) { return s.points; }));
};
exports.showAllLabels = function (_a) {
    var series = _a.series;
    return exports.showDataLabels(flatMap_1.default(series, function (s) { return s.points; }));
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getDataLabelAttributes(point) {
    var _a, _b, _c;
    var dataLabel = (_a = point === null || point === void 0 ? void 0 : point.dataLabel) !== null && _a !== void 0 ? _a : null;
    var parentGroup = (_c = (_b = point === null || point === void 0 ? void 0 : point.dataLabel) === null || _b === void 0 ? void 0 : _b.parentGroup) !== null && _c !== void 0 ? _c : null;
    var labelSafeOffset = -100; // labels outside axis range have typically -9999, hide them
    var labelVisible = dataLabel && dataLabel.x > labelSafeOffset && dataLabel.y > labelSafeOffset;
    if (dataLabel && parentGroup && labelVisible) {
        return {
            x: dataLabel.x + parentGroup.translateX,
            y: dataLabel.y + parentGroup.translateY,
            width: dataLabel.width,
            height: dataLabel.height,
        };
    }
    return {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    };
}
exports.getDataLabelAttributes = getDataLabelAttributes;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function intersectsParentLabel(point, points) {
    var pointParent = parseInt(point.parent, 10);
    // Highchart 7 doesn't render dataLabel at points which have null value
    var pointLabelShape = point.dataLabel;
    if (isNaN(pointParent) || !pointLabelShape) {
        return false;
    }
    var parentPoint = points[pointParent];
    var parentLabelShape = parentPoint.dataLabel;
    return helpers_1.isIntersecting(pointLabelShape, parentLabelShape);
}
exports.intersectsParentLabel = intersectsParentLabel;
function isTruncatedByMin(shape, chart) {
    return shape.y + shape.height > chart.clipBox.height;
}
function isTruncatedByMax(shape) {
    return shape.y < 0;
}
// works for both column/bar chart thanks bar's 90deg rotation
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getShapeVisiblePart(shape, chart, wholeSize) {
    if (isTruncatedByMax(shape)) {
        return shape.y + shape.height;
    }
    else if (isTruncatedByMin(shape, chart)) {
        return chart.clipBox.height - shape.y;
    }
    return wholeSize;
}
exports.getShapeVisiblePart = getShapeVisiblePart;
function getLabelStyle(type, stacking) {
    if (common_1.isAreaChart(type)) {
        return label_1.BLACK_LABEL;
    }
    return stacking || common_1.isOneOfTypes(type, label_1.whiteDataLabelTypes) ? label_1.WHITE_LABEL : label_1.BLACK_LABEL;
}
exports.getLabelStyle = getLabelStyle;
/**
 * A callback function to format data label and `this` is required by Highchart
 * Ref: https://api.highcharts.com/highcharts/yAxis.labels.formatter
 */
function formatAsPercent(unit) {
    if (unit === void 0) { unit = 100; }
    var val = parseFloat((this.value * unit).toPrecision(14));
    return val + "%";
}
exports.formatAsPercent = formatAsPercent;
function isInPercent(format) {
    if (format === void 0) { format = ""; }
    return format.includes("%");
}
exports.isInPercent = isInPercent;
function getLabelsVisibilityConfig(visible) {
    switch (visible) {
        case "auto":
            return {
                enabled: true,
                allowOverlap: false,
            };
        case true:
            return {
                enabled: true,
                allowOverlap: true,
            };
        case false:
            return {
                enabled: false,
            };
        default:
            // keep decision on each chart for `undefined`
            return {};
    }
}
exports.getLabelsVisibilityConfig = getLabelsVisibilityConfig;
//# sourceMappingURL=dataLabelsHelpers.js.map